import { URLS } from "@/config/urls";

export const getUrl = (key: string, params ?: any): string => {
    // const env = process.env || 'test';
    let endpoint: string = process.env.NODE_ENV === "production"? URLS[key]['prod'] : URLS[key]['test'];
    if (params) {
        params.forEach((param: any) => {

            endpoint = endpoint.replace(`{${param.key}}`, param.value)
        })
    }
    return endpoint
}



